import date_format from "@/filters/date/format";
export default {
  install(Vue) {
    Vue.filter('date_format', date_format);
  }
}